import { useMediaQuery } from '@mantine/hooks';

/** Below 760px the shell switches to the mobile layout (compact bar, bottom nav, drawer). */
export const MOBILE_BREAKPOINT = 760;

export function useIsMobile(): boolean {
  return (
    useMediaQuery(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`, false, {
      getInitialValueInEffect: false,
    }) ?? false
  );
}
